import { render, staticRenderFns } from "./ScolarshipForm.vue?vue&type=template&id=12424cfc&"
import script from "./ScolarshipForm.vue?vue&type=script&lang=js&"
export * from "./ScolarshipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports